/* eslint-disable restrict-imports/restrict-imports */
/* eslint-disable complexity */
import React from 'react';
import Dialog from '@material-ui/core/Dialog';

import { IProjectSLAGroup } from '@scale/shared/dailyPlan/dailyPlanProjectGroup';
import ProjectGroupPage from './ProjectGroupPage';
import { CreateProjectGroupResponse } from '@scale/shared/dailyPlan/types/api';

interface ProjectGroupDialogProps {
  onClose: () => void;
  initialValues?: {
    [key: string]: string | string[];
  };
  onSave?: (details?: CreateProjectGroupResponse) => void;
  hideProjects?: boolean;
  skipSave?: boolean;
  returnData?: (details?: IProjectSLAGroup) => void;
}

function ProjectGroupDialog({
  onClose,
  initialValues,
  onSave,
  hideProjects,
  skipSave,
  returnData,
}: ProjectGroupDialogProps) {
  return (
    <Dialog open onClose={onClose} maxWidth={'md'}>
      <div style={{ margin: '20px', maxHeight: '900px', overflowX: 'auto', maxWidth: '650px' }}>
        <ProjectGroupPage
          initialValues={initialValues}
          onSave={onSave}
          onClose={onClose}
          hideProjects={hideProjects}
          skipSave={skipSave}
          returnData={returnData}
        />
      </div>
    </Dialog>
  );
}

export default ProjectGroupDialog;
